<template>
    <div class="flex items-center md:justify-end gap-2 flex-wrap">
        <span class="text-sm font-semibold text-slate-500 sm:inline-block">{{ $t('Sort by') }}</span>
        <Select class="py-1 pl-3 w-auto" v-model="modelValue">
            <option value="price">{{ $t('Price asc') }}</option>
            <option value="-price">{{ $t('Price desc') }}</option>
            <option value="-is_featured">{{ $t('Our top picks') }}</option>
            <option value="-avg_rating">{{ $t('Customer reviews') }}</option>
        </Select>
    </div>
</template>

<script setup>
const modelValue = defineModel('modelValue', {
    type: String,
    default: ''
})
</script>
